<app-breadcrumb [title]="'Riesgos de la Zona'" [items]="['Pesv', 'Zonas de vías']"
  [active_item]="zonaActual?.nombre || 'Riesgos de vías'"></app-breadcrumb>

<div class="container-fluid">
  <div class="card">
    <div class="card-header d-flex align-items-center justify-content-between bg-primary text-white">
      <div class="d-flex align-items-center">
        <i class="fa fa-exclamation-triangle me-2"></i>
        <h5 class="mb-0"><strong>RIESGOS DE LA ZONA {{ zonaActual?.codigo }} - {{ zonaActual?.nombre }}</strong></h5>
      </div>
      <button type="button" class="btn btn-light btn-sm" (click)="volver()">
        <i class="fa fa-arrow-left me-1"></i>Volver a zonas
      </button>
    </div>

    <div class="card-body">
      <ul class="nav nav-tabs mb-4">
        <li class="nav-item">
          <button type="button" class="nav-link" [class.active]="activeTab === 1" (click)="activeTab = 1">
            <i class="fa fa-plus me-1"></i>{{ editando ? 'Editar riesgo' : 'Registrar riesgo' }}
          </button>
        </li>
        <li class="nav-item">
          <button type="button" class="nav-link" [class.active]="activeTab === 2" (click)="mostrarListado()">
            <i class="fa fa-list me-1"></i>Listado de riesgos
          </button>
        </li>
      </ul>

      <form *ngIf="activeTab === 1" [formGroup]="form" (ngSubmit)="guardar()">
        <div class="panel-section mb-4">
          <div class="panel-title">
            <i class="fa fa-info-circle me-2"></i>
            1. Información general
          </div>

          <div class="row g-3 mt-2">
            <div class="col-md-6">
              <label class="form-label">Vía interna:</label>
              <input type="text" class="form-control" [value]="nombreVia(zonaActual?.via_id)" readonly />
            </div>

            <div class="col-md-6">
              <label class="form-label">Zona:</label>
              <input type="text" class="form-control" [value]="zonaActual?.codigo + ' - ' + zonaActual?.nombre" readonly />
            </div>

            <div class="col-md-3">
              <label class="form-label required">Código: <span class="text-danger">*</span></label>
              <input type="text" class="form-control" formControlName="codigo" placeholder="RV-001" />
            </div>

            <div class="col-md-3">
              <label class="form-label required">Fecha de identificación: <span class="text-danger">*</span></label>
              <input type="date" class="form-control" formControlName="fecha_identificacion" />
            </div>

            <div class="col-md-6">
              <label class="form-label required">Tipo de riesgo: <span class="text-danger">*</span></label>
              <ng-select [items]="tiposRiesgo" placeholder="Seleccione un tipo de riesgo" bindLabel="descripcion"
                bindValue="id" formControlName="tipo_riesgo">
              </ng-select>
            </div>

            <div class="col-md-6">
              <label class="form-label">Tipo de conflicto: <span class="text-dark">(Opcional)</span></label>
              <ng-select [items]="tiposConflicto" bindLabel="descripcion" bindValue="id" placeholder="Seleccione un tipo de conflicto"
                formControlName="tipo_conflicto">
              </ng-select>
            </div>

            <div class="col-md-12">
              <label class="form-label required">Descripción del riesgo: <span class="text-danger">*</span></label>
              <textarea class="form-control" rows="3" formControlName="descripcion"
                placeholder="Describa el riesgo identificado"></textarea>
            </div>
          </div>
        </div>

        <div class="panel-section mb-4">
          <div class="panel-title">
            <i class="fa fa-users me-2"></i>
            2. Actores y condiciones
          </div>

          <div class="row g-3 mt-2">
            <div class="col-md-6">
              <label class="form-label">Actor vial 1: <span class="text-dark">(Opcional)</span></label>
              <ng-select [items]="actoresViales" placeholder="Seleccione un actor vial" bindLabel="descripcion"
                bindValue="id" formControlName="actor_vial_1">
              </ng-select>
            </div>

            <div class="col-md-6">
              <label class="form-label">Actor vial 2: <span class="text-dark">(Opcional)</span></label>
              <ng-select [items]="actoresViales" placeholder="Seleccione un actor vial" bindLabel="descripcion"
                bindValue="id" formControlName="actor_vial_2">
              </ng-select>
            </div>

            <div class="col-md-6">
              <label class="form-label">Condición detectada: <span class="text-dark">(Opcional)</span></label>
              <textarea class="form-control" rows="3" formControlName="condicion_detectada"></textarea>
            </div>

            <div class="col-md-6">
              <label class="form-label">Control existente: <span class="text-dark">(Opcional)</span></label>
              <textarea class="form-control" rows="3" formControlName="control_existente"></textarea>
            </div>
          </div>
        </div>

        <div class="panel-section mb-4">
          <div class="panel-title">
            <i class="fa fa-bar-chart me-2"></i>
            3. Evaluación del riesgo
          </div>

          <div class="row g-3 mt-2">
            <div class="col-md-3">
              <label class="form-label">Probabilidad: <span class="text-dark">(Opcional)</span></label>
              <ng-select [items]="probabilidades" bindLabel="descripcion" bindValue="id" placeholder="Seleccione la probabilidad" bindLabel="descripcion"
                bindValue="id" formControlName="probabilidad">
              </ng-select>
            </div>

            <div class="col-md-3">
              <label class="form-label">Consecuencia: <span class="text-dark">(Opcional)</span></label>
              <ng-select [items]="consecuencias" bindLabel="descripcion" bindValue="id" placeholder="Seleccione la consecuencia" bindLabel="descripcion"
                bindValue="id" formControlName="consecuencia">
              </ng-select>
            </div>

            <div class="col-md-3">
              <label class="form-label">Nivel de riesgo: <span class="text-dark">(Opcional)</span></label>
              <ng-select [items]="nivelesRiesgo" placeholder="Seleccione un nivel" bindLabel="descripcion"
                bindValue="id" formControlName="nivel_riesgo">
              </ng-select>
            </div>

            <div class="col-md-3">
              <label class="form-label">Prioridad: <span class="text-dark">(Opcional)</span></label>
              <ng-select [items]="nivelesRiesgo" placeholder="Seleccione la prioridad" bindLabel="descripcion"
                bindValue="id" formControlName="prioridad">
              </ng-select>
            </div>

            <div class="col-md-3">
              <label class="form-label">Requiere intervención:</label>
              <ng-select [items]="opcionesIntervencion" bindLabel="descripcion" bindValue="id"
                [clearable]="false" formControlName="requiere_intervencion">
              </ng-select>
            </div>
          </div>
        </div>

        <div class="panel-section mb-4">
          <div class="panel-title">
            <i class="fa fa-comment me-2"></i>
            4. Observaciones
          </div>

          <div class="row g-3 mt-2">
            <div class="col-md-12">
              <label class="form-label">Observaciones: <span class="text-dark">(Opcional)</span></label>
              <textarea class="form-control" rows="3" formControlName="observaciones"></textarea>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-between align-items-center mt-4 flex-wrap gap-3">
          <div class="d-flex gap-2">
            <button type="button" class="btn btn-light border text-secondary px-4"
              (click)="cancelar()">Cancelar</button>

            <button type="submit" class="btn btn-primary px-4" [disabled]="guardando">{{ guardando ? 'Guardando...' :
              'Guardar' }}</button>
          </div>
        </div>
      </form>

      <div *ngIf="activeTab === 2">
        <div class="row mb-3 align-items-center">
          <div class="col-md-4">
            <input type="search" class="form-control" [(ngModel)]="filtro" (input)="aplicarFiltro()"
              placeholder="Buscar por código, vía, zona o tipo..." />
          </div>
        </div>

        <div *ngIf="cargandoListado" class="text-center py-4">
          <span class="spinner-border text-primary"></span>
          <p class="mt-2 mb-0">Cargando riesgos...</p>
        </div>

        <div *ngIf="!cargandoListado" class="table-responsive">
          <table id="tblViasRiesgos" class="table table-bordered table-hover align-middle">
            <thead class="bg-primary text-white">
              <tr>
                <th class="text-center">CÓDIGO</th>
                <th class="text-center">VÍA</th>
                <th class="text-center">ZONA</th>
                <th class="text-center">TIPO DE RIESGO</th>
                <th class="text-center">TIPO DE CONFLICTO</th>
                <th class="text-center">FECHA IDENTIFICACIÓN</th>
                <th class="text-center">NIVEL DE RIESGO</th>
                <th class="text-center">PRIORIDAD</th>
                <th class="text-center">REQUIERE INTERVENCIÓN</th>
                <th class="text-center">ESTADO</th>
                <th class="text-center">ACCIONES</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let riesgo of riesgosFiltrados | paginate: { itemsPerPage: pageSize, currentPage: page }">
                <td class="text-center">{{ riesgo.codigo }}</td>
                <td class="text-center">{{ riesgo.ViaInternaViasData?.codigoNombre }}</td>
                <td class="text-center">{{ riesgo.ViaZonaViasData?.codigoNombre }}</td>
                <td class="text-center">{{ riesgo.TiposRiesgoVialData?.descripcion }}</td>
                <td class="text-center">{{ riesgo.TipoConflictoViasData?.descripcion }}</td>
                <td class="text-center">{{ formatearFecha(riesgo.fecha_identificacion) }}</td>
                <td class="text-center">
                  <span *ngIf="riesgo.nivel_riesgo != null" class="badge" [ngClass]="claseRiesgo(riesgo.nivel_riesgo)">
                    {{ riesgo.NivelRiesgoData?.descripcion }}
                  </span>
                </td>
                <td class="text-center">{{ riesgo.PrioridadData?.descripcion }}</td>
                <td class="text-center">
                  <span class="badge"
                    [ngClass]="Number(riesgo.requiere_intervencion) === 1 ? 'bg-warning text-dark' : 'bg-secondary'">
                    {{ Number(riesgo.requiere_intervencion) === 1 ? 'SÍ' : 'NO' }}
                  </span>
                </td>
                <td class="text-center">
                  <span class="badge" [ngClass]="Number(riesgo.estado) === 1 ? 'bg-success' : 'bg-secondary'">
                    {{ Number(riesgo.estado) === 1 ? 'ACTIVO' : 'INACTIVO' }}
                  </span>
                </td>
                <td class="text-center">
                  <button type="button" class="btn btn-sm btn-outline-primary me-1 rounded-pill btn-rounded"
                    (click)="editarRiesgo(riesgo)" [disabled]="Number(riesgo.estado) !== 1" title="Editar">
                    <i class="fa fa-pencil"></i>
                  </button>
                  <button type="button" class="btn btn-sm rounded-pill btn-rounded"
                    [ngClass]="Number(riesgo.estado) === 1 ? 'btn-outline-danger' : 'btn-outline-success'"
                    (click)="cambiarEstado(riesgo)" [title]="Number(riesgo.estado) === 1 ? 'Inactivar' : 'Activar'">
                    <i class="fa" [ngClass]="Number(riesgo.estado) === 1 ? 'fa-ban' : 'fa-check'"></i>
                  </button>
                </td>
              </tr>
              <tr *ngIf="!riesgosFiltrados.length">
                <td colspan="10" class="text-center text-primary py-4">No hay riesgos registrados.</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="d-flex justify-content-between align-items-center mt-4" *ngIf="riesgosFiltrados.length > 0">
          <div class="d-flex align-items-center">
            <label class="me-2">Mostrar:</label>
            <select class="form-select w-auto" [(ngModel)]="pageSize" (change)="page = 1">
              <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">{{ size }}</option>
            </select>
            <span class="ms-2">registros por página</span>
          </div>
          <div class="text-center flex-grow-1">
            Total Registros: <a class="badge badge-primary"><b>{{ riesgosFiltrados?.length || 0 }}</b></a>
          </div>
          <div class="text-end paginador-personalizado">
            <pagination-controls (pageChange)="page = $event" [maxSize]="5" [directionLinks]="true"
              [autoHide]="true" previousLabel="Anterior" nextLabel="Siguiente"></pagination-controls>
          </div>
        </div>

        <div class="btn-showcase text-center mt-4" *ngIf="riesgosFiltrados.length">
          <button type="button" class="btn btn-outline-success-2x me-2" (click)="exportarExcel()">
            <i class="icofont icofont-file-excel"></i> EXCEL
          </button>
          <button type="button" class="btn btn-outline-danger-2x" (click)="exportarPdf()">
            <i class="icofont icofont-file-pdf"></i> PDF
          </button>
        </div>
      </div>
    </div>
  </div>
</div>